import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import { NAV_LINKS } from 'ui/navLinks';

const Nav = () => {
  const [activeItem, setActiveItem] = useState('');
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.startsWith('/account')) {
      setActiveItem('');
      return;
    }

    const activeLink = NAV_LINKS.find((link) => currentPath.startsWith(link.url));
    if (activeLink) {
      setActiveItem(activeLink.name);
    }
  }, [location.pathname]);

  const handleItemClick = (e, { name, url }) => {
    setActiveItem(name);
    history.push(url);
  };

  return (
    <div className="app-nav-bottom">
      {NAV_LINKS.map((link) => {
        const isActive = activeItem === link.name;

        return (
          <div
            key={link.url}
            onClick={() => handleItemClick(null, { name: link.name, url: link.url })}
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              color: isActive ? 'white' : 'rgba(255,255,255,0.7)',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              height: '100%',
              padding: 0
            }}
          >
            <div
              style={{
                width: '50px',
                height: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '50%',
                backgroundColor: isActive ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
                transition: 'background-color 0.2s ease'
              }}
            >
              <Icon
                name={link.icon}
                style={{
                  margin: 0,
                  fontSize: '2rem',
                  lineHeight: 1,
                  opacity: isActive ? 1 : 0.7
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Nav;
